export default "__VITE_ASSET__CTB$qOmU__"